import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { Button } from 'antd'
import { FormPage, EasyModal, EasyIcon, FormPropsContext, ListPropsContext } from 'src/components'
import { listStore } from 'src/stores'
import { $consts } from 'src/plugins'

type Props = {
  config: ButtonConfig
}

const BatchAddBtn = (props: Props) => {
  const formProps = useContext(FormPropsContext)
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const handleModalClose = () => {
    table?.reload()
  }

  const fromListRow = useMemo(() => {
    const fromWhere = formProps.formData?.fromWhere
    return (
      fromWhere?.pageType === $consts['TABLE/FORM_TYPE_LIST_PAGE']
      && fromWhere?.locateType === $consts['TABLE/BTN_LOCATE_ROW']
      && fromWhere?.data
    )
  }, [formProps.formData?.fromWhere])

  const formData = useMemo(() => {
    return {
      fromWhere: {
        pageType: $consts['TABLE/FORM_TYPE_LIST_PAGE'],
        locateType: $consts['TABLE/BTN_LOCATE_HEADER'],
        funcType: $consts['TABLE/FUNC_TYPE_BATCH_SAVE'],
        funcData: props.config,
        data: fromListRow
      },
      filterGroup: formProps.formData?.filterGroup,
    }
  }, [fromListRow])

  const { LABEL, ICON, FORM_CODE, WIDTH } = props.config
  return (
    <EasyModal
      modal={{ title: FORM_CODE, width: WIDTH }}
      onClose={handleModalClose}
      slot={<Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='PlusOutlined' />}>{LABEL}</Button>}
    >
      <FormPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

export default BatchAddBtn